import { useState } from "react";
import { X, Check } from "lucide-react";
import { money } from "@/lib/currency";
import { addonSum } from "@/lib/addons";
import { useT } from "@/lib/i18n";

export const AddonSheet = ({ item, cur, accent, onAdd, onClose }) => {
  const { t } = useT();
  const [picked, setPicked] = useState([]);
  const toggle = (a) => setPicked((p) => (p.some((x) => x.id === a.id) ? p.filter((x) => x.id !== a.id) : [...p, a]));
  const total = item.price + addonSum(picked);

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-end justify-center" onClick={onClose}>
      <div data-testid="addon-sheet" className="w-full max-w-md bg-[#FAF7F2] rounded-t-3xl p-5 pb-safe max-h-[85dvh] overflow-y-auto no-scrollbar fade-up" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h2 className="font-heading text-xl font-bold text-[#1F1D1B]">{item.name}</h2>
            <p className="text-sm text-[#6B6560] font-mono-j">{money(item.price, cur)}</p>
          </div>
          <button data-testid="close-addon-sheet" onClick={onClose} className="text-[#6B6560]"><X className="h-6 w-6" /></button>
        </div>
        <p className="mt-4 text-xs font-semibold uppercase tracking-wider text-[#6B6560]">{t("extras")} · {t("optional")}</p>
        <div className="mt-2 space-y-2">
          {item.addons.map((a) => {
            const on = picked.some((x) => x.id === a.id);
            const off = a.available === false;
            return (
              <button key={a.id} type="button" disabled={off} data-testid={`addon-option-${a.id}`} onClick={() => toggle(a)}
                className={`w-full flex items-center gap-3 bg-white border rounded-xl px-3.5 py-3 text-left transition-colors ${off ? "opacity-50" : ""}`}
                style={{ borderColor: on ? accent : "#E6E1DA" }}>
                <span className="h-5 w-5 rounded-md border grid place-items-center shrink-0" style={on ? { backgroundColor: accent, borderColor: accent } : { borderColor: "#CFC8BE" }}>
                  {on && <Check className="h-3.5 w-3.5 text-white" />}
                </span>
                <span className="flex-1 text-sm text-[#1F1D1B]">{a.name}</span>
                {off ? <span className="text-[10px] font-semibold uppercase text-red-600">{t("soldOut")}</span> : <span className="text-sm font-mono-j text-[#6B6560]">+{money(a.price, cur)}</span>}
              </button>
            );
          })}
        </div>
        <button data-testid="addon-sheet-add-button" onClick={() => onAdd(item, picked)} className="w-full mt-5 rounded-full py-4 font-bold text-white flex items-center justify-between px-6 transition-transform active:scale-[0.98]" style={{ backgroundColor: accent }}>
          <span>{t("addToOrder")}</span>
          <span className="font-mono-j">{money(total, cur)}</span>
        </button>
      </div>
    </div>
  );
};
